import { useEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  ItsButtonSearchField,
  type ItsButtonSearchHandle,
  normalizeItsQuery,
} from "@/components/its-lookup";

/** ITS lookup that fills organiser + phone for booking create/edit forms. */
function BookingItsLookup() {
  const { control, setValue, getValues } = useFormContext();
  const formItsNo = useWatch({ control, name: "itsNo" });
  const searchRef = useRef<ItsButtonSearchHandle>(null);
  const lastAutoLookupIts = useRef<string | null>(null);

  useEffect(() => {
    const normalizedIts = normalizeItsQuery(formItsNo);
    if (!normalizedIts) return;
    const phoneValue = String(getValues("phone") ?? "").trim();
    if (phoneValue) return;
    if (lastAutoLookupIts.current === normalizedIts) return;

    lastAutoLookupIts.current = normalizedIts;
    searchRef.current?.search(normalizedIts);
  }, [formItsNo, getValues]);

  return (
    <ItsButtonSearchField
      ref={searchRef}
      source="itsNo"
      label="ITS No"
      isRequired
      boxSx={{ display: "flex", alignItems: "flex-start" }}
      onFound={(record) => {
        setValue("itsNo", record.ITS_ID, { shouldDirty: true, shouldValidate: true });
        setValue("organiser", record.Full_Name, { shouldDirty: true, shouldValidate: true });
        setValue("phone", record.Mobile, { shouldDirty: true, shouldValidate: true });
      }}
    />
  );
}

export default BookingItsLookup;
